import React from 'react'
import Scrollspy from 'react-scrollspy'
// import Scroll from './Scroll'
import { Link } from 'gatsby'

const Nav = props => (
  <nav id="nav" className={props.sticky ? 'alt' : ''}>
    <Scrollspy items={['intro', 'first', 'second', 'cta']} offset={-300}>
      <li>
        {/* <Scroll type="id" element="intro"> */}
        <Link to="/" activeClassName="active">
          Startseite
        </Link>
        {/* </Scroll> */}
      </li>
      <li>
        <Link to="/psychotherapie" activeClassName="active">
          Psychotherapie
        </Link>
      </li>
      <li>
        <Link to="/erstkontakt" activeClassName="active">
          Erstkontakt
        </Link>
      </li>
      <li>
        <Link to="/wartezeiten" activeClassName="active">
          Wartezeiten
        </Link>
      </li>
      <li>
        <Link to="/qualitaetsstandards" activeClassName="active">
          Qualitätsstandards
        </Link>
      </li>
      <li>
        <Link to="/zu-meiner-person" activeClassName="active">
          zu meiner Person
        </Link>
      </li>
      <li>
        <Link to="/fragen" activeClassName="active">
          Fragen?
        </Link>
      </li>
      <li>
        <Link to="/kontakt" activeClassName="active">
          Kontakt
        </Link>
      </li>
      <li>
        <Link to="/links" activeClassName="active">
          Links
        </Link>
      </li>
      <li>
        <Link to="/impressum" activeClassName="active">
          Impressum
        </Link>
      </li>
    </Scrollspy>
  </nav>
)

export default Nav
